import LectureLessonStatusResourceListResultModel from '../../generated/types/model/resource/LectureLessonStatusResourceListResultModel';

export default class LectureLessonStatusResourceListResultViewModel extends LectureLessonStatusResourceListResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
